import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBaseCrossField = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 0.833374C11.9578 0.83355 15.1658 4.0426 15.166 8.00037C15.1658 11.9581 11.9578 15.1662 8 15.1664C4.04218 15.1663 0.833184 11.9582 0.833008 8.00037C0.833206 4.04257 4.04219 0.833506 8 0.833374ZM10.3535 5.64685C10.1583 5.45159 9.84175 5.45159 9.64648 5.64685L8 7.29333L6.35352 5.64685C6.15825 5.45159 5.84175 5.45159 5.64648 5.64685C5.45122 5.84211 5.45122 6.15862 5.64648 6.35388L7.29297 8.00037L5.64648 9.64685C5.45122 9.84211 5.45122 10.1586 5.64648 10.3539C5.84175 10.5491 6.15825 10.5491 6.35352 10.3539L8 8.7074L9.64648 10.3539C9.84175 10.5491 10.1583 10.5491 10.3535 10.3539C10.5488 10.1586 10.5488 9.84211 10.3535 9.64685L8.70703 8.00037L10.3535 6.35388C10.5488 6.15862 10.5488 5.84211 10.3535 5.64685Z",
		fill: "currentColor",
		fillOpacity: .6
	})
});
export default SvgIconBaseCrossField;
